export const routesWithoutDrawer = [
  "Register",
  "Login",
  "ForgotPassword",
  "ResetPassword"
];
